const xlsDownloader = (data) => {
  const blob = new Blob([data]);
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('data-testid', 'download');
  link.href = url;
  link.setAttribute('download', `Histori-kuliah-umum${new Date()}.xls`);
  document.body.appendChild(link);
  link.click();
};

export default xlsDownloader;
